export const ScreenSize = {
  XXS: 0,
  XS: 480,
  SM: 544,
  MD: 768,
  LG: 992,
  XL: 1200,
  Desktop: 1025
};